import FlexiInputText from "slotworks/graphics/elements/flexi-input-text";
import Layers from "slotworks/graphics/layers/layers";
import ControlOptions from "slotworks/smart-ui/options/control-options";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";
import AbstractNumberInputControl from "../abstract/abstract-number-input-control";

export default class CustomSingleWinLimitInputControl extends AbstractNumberInputControl {

    protected input: FlexiInputText;

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);
    }

    public updateOptions(options: ControlOptions) {
        const limitValues = options.getValidSingleWinLimits();

        if (!this.setupData) {

            if (!limitValues || limitValues.length === 0) {
                this.setEnabled(false);
            } else {
                if (limitValues[0] !== 0) {
                    limitValues.unshift(0);
                }

                this.setMinMaxRange(limitValues[0], limitValues[limitValues.length - 1]);

                this.input.setDefaults(this.min.toString());
            }

            this.setupData = true;
        }

        if (options.customSingleWinLimitSelected && limitValues && limitValues.length > 0) {
            this.input.setVisible(true);
            this.input.focus();

            if (options.singleWinLimit.currentValue > 0) {
                this.resetValue();
            }
        } else {
            this.input.setVisible(false);
        }

        super.updateOptions(options);
    }

    protected onChangeHandler() {
        const value = this.getValidatedCurrency();

        if (value >= 0) {
            const options = new ControlOptions();

            options.singleWinLimit.currentValue = value;
            options.customSingleWinLimitSelected = false;

            this.onChange.dispatch(options);
        } else {
            this.input.setText("");
        }
    }

    private resetValue() {
        this.input.setText("");
    }
}
